let runValidators = (obj) => {
    //let { validators } = obj
    for (var prop in obj) {

        //let propValidators = validators.find(v => v.item == prop)
        let propValidators = getValidators(obj, prop)
        if (propValidators) {
            let isValid = true
            propValidators.validators.forEach(validator => { if (!validator(obj[prop], obj)) { isValid = false } })
            propValidators.isValid = isValid
        }
    }
}

let getValidators = (obj, prop) => {
    return obj.validators.find(v => v.item == prop)
}

let getValidatorsIsValid = (obj) => {
    for (var prop in obj) {
        let propValidators = getValidators(obj, prop)
        if (propValidators) {
            if (!propValidators.isValid)
                return false
        }
    }
    return true
}

export { runValidators, getValidators, getValidatorsIsValid }